'use client';

import { type Cart } from '@shopify/hydrogen-react/storefront-api-types';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { cartAtom } from '../atoms/cartAtom';

export const CartProvider = ({
  children,
  cart,
}: {
  children: React.ReactNode;
  cart: Cart;
}) => {
  const setCart = useSetAtom(cartAtom);

  useEffect(() => setCart(cart), []);

  return children;
};
